export const KEY = "@Modals/";
export const SHOW_MODAL = `${KEY}SHOW_MODAL`;
export const HIDE_MODAL = `${KEY}HIDE_MODAL`;
